import { createFileRoute } from "@tanstack/react-router";
import { ComparisonPage } from "@/components/products/ComparisonPage";
import { productsIndexSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/products/")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => productsIndexSeo(loaderData?.href ?? "/products"),
  component: ComparisonPage,
});
